import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { CutStatusMetrics } from '@/models/deviceStatusMetrics';
import { getStateCss } from '@/utils/color';
import { isNil } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CutStatus',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: CutStatusMetrics | null;
};



const { t } = useI18n();

const state = computed<string>(() =>
  !isNil(props.data?.last_state) ? props.data.last_state : 'no_communication',
);

const stateStyle = computed<string>(() =>
  props.data?.last_state ? getStateCss(state.value) : '',
);

return { __sfc: true,props, t, state, stateStyle }
}

})